import { __extends } from "tslib";
import * as React from 'react';
import withPlaybackContext from '../../common/withPlaybackContext';
import { classes } from './Forward.st.css';
var Forward = /** @class */ (function (_super) {
    __extends(Forward, _super);
    function Forward() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleClick = function () {
            var nextTime = _this.props.context.currentTime + _this.props.increment;
            _this.props.context.seekTo(nextTime);
        };
        return _this;
    }
    Forward.prototype.render = function () {
        return (React.createElement("button", { className: classes.button + " " + this.props.className, "data-hook": this.props.dataHook, onClick: this.handleClick }, this.props.icon));
    };
    Forward.displayName = 'Forward';
    Forward.defaultProps = {
        className: '',
        dataHook: '',
        icon: '<span />',
        increment: 15,
    };
    return Forward;
}(React.Component));
export default withPlaybackContext(Forward);
//# sourceMappingURL=Forward.js.map